module.exports = __webpack_public_path__ + "img/map.542ecd61.svg";